import { useEffect, useState } from "react";
import DialogInfoGeneral from "./DialogInfoGeneral";
import process from "process";

function VersionCheck() {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);

  useEffect(() => {
    const version = process?.env?.REACT_APP_VERSION;

    if (version) {
      try {
        const storedVersion = localStorage.getItem("isf_version");

        if (storedVersion !== version) {
          setShowUpdateNotification(true);
        }
        if(!storedVersion){
          handleUpdate()
        }
      } catch (error) {
        console.error("Error accessing localStorage:", error);
      }
    } else {
      console.warn("REACT_APP_VERSION is undefined.");
    }
  }, []);

  const handleUpdate = () => {
    try{
      localStorage.setItem("isf_version", process?.env?.REACT_APP_VERSION || "");
    }catch(e){
      console.error('no fue posible almacenar versión',e)
    }
    window.location.reload();
  };

  return (
    <div>
      <DialogInfoGeneral
        show={showUpdateNotification}
        closeDialog={() => setShowUpdateNotification(false)} // Corregido
        disabledClosable={true}
        disabledFooter={true}
      >
        <div className="opensans py-10 text-center">
          <p className="text-lg text-center">Hay una nueva versión disponible.</p>
          <p className="text-lg font-bold"> ¿Desea actualizar?</p>
          <div className="flex items-center justify-center gap-4 text-base font-bold">
            <button className="bg-green-admin border border-green-admin text-white px-2 py-2 rounded-md" onClick={handleUpdate}>Actualizar</button>
            <button className="bg-stone-100 border border-stone-200 px-2 py-2 rounded-md" onClick={handleUpdate}>Más tarde</button>
          </div>
        </div>
      </DialogInfoGeneral>
    </div>
  );
}

export default VersionCheck;